import React, { useState, useEffect } from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import circleSwapLoader from '../../assets/Loading/Circle Swap Loading.lottie';
import './LoadingScreen.css';

export default function Spinner({ delay = 300 }) {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldShow(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!shouldShow) return null;

  return (
    <div className="loading-overlay">
      <div className="loading-animation-wrapper">
        <DotLottieReact
          src={circleSwapLoader}
          autoplay
          loop
        />
      </div>
    </div>
  );
}
